export const required = (value: any) =>
  value || typeof value === 'number' ? undefined : 'Required';
export const maxLength = (max: number) => (value: string) =>
  value && value.length > max ? `Must be ${max} chars or less` : undefined;
export const minLength = (min: number) => (value: string) =>
  value && value.length < min ? `Must be ${min} chars or more` : undefined;
export const number = (value: any) =>
  value && isNaN(Number(value)) ? 'Must be a number' : undefined;
export const alphaNumeric = (value: string) =>
  value && /[^a-zA-Z0-9 ]/i.test(value) ? 'Only alphanumeric chars' : undefined;
